(function () {
  var BODY_CLASS = 'ig-id24-v1';

  function normalizeVariant(variant) {
    var value = String(variant || '').toLowerCase();
    if (value === 'v1' || value === 'variant' || value === 'a') return 'v1';
    if (value === 'control' || value === 'c') return 'control';
    return null;
  }

  function queryVariant() {
    var match = (window.location.search || '').match(/(?:^|[?&])id24=([^&]+)/);
    if (!match) return null;
    try {
      return normalizeVariant(decodeURIComponent(match[1].replace(/\+/g, ' ')));
    } catch (e) {
      return normalizeVariant(match[1]);
    }
  }

  function applyVariant(variant) {
    var next = normalizeVariant(variant);
    if (!next) next = 'control';
    var on = next === 'v1';
    document.documentElement.classList.toggle(BODY_CLASS, on);
    if (document.body) document.body.classList.toggle(BODY_CLASS, on);
  }

  window.igId24ApplyVariant = function (variant) {
    window.__igId24Pending = null;
    applyVariant(variant);
  };

  if (window.__igId24Pending) {
    var pending = window.__igId24Pending;
    window.__igId24Pending = null;
    applyVariant(pending);
    return;
  }

  var fromQuery = queryVariant();
  if (fromQuery) applyVariant(fromQuery);
})();
